// extracted by mini-css-extract-plugin
export default {"acceptInvitation":"AcceptBusinessInvitation_acceptInvitation__57g8s","panel":"AcceptBusinessInvitation_panel__AIDP5","error":"AcceptBusinessInvitation_error__jLt5y"};